import { unreadCount } from "../../module/chat-unread-count";
export const initMypageUpdateUnReadCount = async () => {
    const userId = document.getElementById("my_user_id");
    if (userId == null) {
        return;
    }
    if (location.href.indexOf("/u/mypage/index") != -1 && document.referrer.indexOf("/u/box/") != -1) {
        unreadCount(Number(userId.value));
    }
};
